<template>
  <div class="app-wrapper">
    <!-- Sidebar -->
    <nav>
      <div :class="{ 'open': isNavbarOpen }" class="app-logo">
        <router-link class="logo d-inline-block" :class="{ 'toggle-nav': isMobile }" to="/">
          <img src="/assets/images/logo/shc-logo.png" alt="Sheria Housing">
        </router-link>
        <span class="bg-light-primary toggle-semi-nav toggle-nav">
          <i class="ti ti-chevrons-right f-s-20"></i>
        </span>
      </div>

      <div :class="{ 'open': isNavbarOpen }" class="app-nav d-flex flex-column" id="app-simple-bar">
        <ul class="main-nav p-0 mt-2 flex-grow-1">
          <li v-for="item in navItems" :key="item.path">
            <router-link :to="item.path" :class="{ 'toggle-nav': isMobile, 'active': $route.path === item.path }" class="nav-link-item">
              <i :class="item.icon"></i>
              {{ item.label }}
            </router-link>
          </li>
        </ul>

        <ul class="main-nav p-0 mb-3">
          <li>
            <a href="#" :class="{ 'toggle-nav': isMobile }" @click.prevent="handleLogout" class="nav-link-item text-danger">
              <i class="ph-duotone ph-sign-out"></i>
              Logout
            </a>
          </li>
        </ul>
      </div>

      <div class="menu-navs">
        <span class="menu-previous"><i class="ti ti-chevron-left"></i></span>
        <span class="menu-next"><i class="ti ti-chevron-right"></i></span>
      </div>
    </nav>

    <!-- Main Content -->
    <div class="app-content">
      <div class="">
        <!-- Header -->
        <header class="header-main">
          <div class="container-fluid">
            <div class="row">
              <div class="col-6 col-sm-4 d-flex align-items-center header-left p-0">
                <span class="header-toggle me-3">
                  <i class="ph ph-circles-four"></i>
                </span>
                <div class="d-none d-sm-block">
                  <h6 class="mb-0 fw-semibold text-dark" style="letter-spacing: 0.3px;">{{ pageTitle }}</h6>
                </div>
              </div>

              <div class="col-6 col-sm-8 d-flex align-items-center justify-content-end header-right p-0">
                <div class="d-flex align-items-center gap-3">
                  <div class="d-none d-md-flex align-items-center gap-2 me-2">
                    <div class="rounded-circle d-flex align-items-center justify-content-center" 
                         style="width: 36px; height: 36px; background: linear-gradient(135deg, #0891b2, #06b6d4);">
                      <span class="text-white fw-bold f-s-14">{{ userInitials }}</span>
                    </div>
                    <div>
                      <p class="mb-0 fw-semibold f-s-14 text-dark" style="text-transform: capitalize; line-height: 1.2;">{{ store.userName }}</p>
                      <p class="mb-0 f-s-12 text-muted">{{ store.memberNumber }}</p>
                    </div>
                  </div>

                  <ul class="d-flex align-items-center mb-0">
                    <li class="header-profile">
                      <a href="#" class="d-block head-icon" role="button" data-bs-toggle="offcanvas"
                        data-bs-target="#appscanvasRights" aria-controls="appscanvasRights">
                        <i class="ph ph-bounding-box"></i>
                      </a>

                      <div class="offcanvas offcanvas-end header-apps-canvas" tabindex="-1" id="appscanvasRights" style="max-width: 380px;">
                        <div class="offcanvas-header border-0 pb-0 pt-4 px-4">
                          <div>
                            <h5 class="offcanvas-title fw-bold" style="color: #0f172a;">Quick Actions</h5>
                            <p class="text-muted f-s-12 mb-0">Navigate to key sections</p>
                          </div>
                          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div class="offcanvas-body px-4 pt-3 app-scroll">
                          <!-- User Card -->
                          <div class="d-flex align-items-center p-3 mb-4 rounded-3" style="background: linear-gradient(135deg, #0891b2, #06b6d4);">
                            <div class="rounded-circle d-flex align-items-center justify-content-center me-3"
                                 style="width: 44px; height: 44px; background: rgba(255,255,255,0.25); flex-shrink: 0;">
                              <span class="text-white fw-bold f-s-16">{{ userInitials }}</span>
                            </div>
                            <div style="min-width: 0;">
                              <p class="mb-0 text-white fw-semibold f-s-14" style="text-transform: capitalize; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ store.userName }}</p>
                              <p class="mb-0 f-s-12" style="color: rgba(255,255,255,0.7);">{{ store.memberNumber }}</p>
                            </div>
                          </div>

                          <!-- Quick Action Grid -->
                          <div class="row g-3 mb-4">
                            <div class="col-6" v-for="item in quickActions" :key="'quick-' + item.path">
                              <a href="#" class="d-block text-decoration-none" @click.prevent="navigateQuickAction(item.path)">
                                <div class="quick-action-card text-center p-3 rounded-3" 
                                     :style="'background:' + item.bg + '; transition: transform 0.2s; cursor: pointer;'"
                                     @mouseover="$event.currentTarget.style.transform='translateY(-2px)'"
                                     @mouseout="$event.currentTarget.style.transform='translateY(0)'">
                                  <div class="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                       :style="'width: 48px; height: 48px; background:' + item.iconBg + ';'">
                                    <i :class="item.icon + ' f-s-22'" :style="'color:' + item.iconColor + ';'"></i>
                                  </div>
                                  <p class="mb-0 fw-semibold f-s-13" :style="'color:' + item.textColor + ';'">{{ item.label }}</p>
                                </div>
                              </a>
                            </div>
                          </div>

                          <!-- Bottom Actions -->
                          <div class="border-top pt-3">
                            <a href="#" class="d-flex align-items-center p-3 rounded-3 text-decoration-none mb-2"
                               style="background: #fef2f2; transition: background 0.2s;"
                               @click.prevent="handleLogout"
                               @mouseover="$event.currentTarget.style.background='#fee2e2'"
                               @mouseout="$event.currentTarget.style.background='#fef2f2'">
                              <div class="rounded-circle d-flex align-items-center justify-content-center me-3"
                                   style="width: 40px; height: 40px; background: #fecaca; flex-shrink: 0;">
                                <i class="ph-duotone ph-sign-out f-s-18" style="color: #ef4444;"></i>
                              </div>
                              <div>
                                <p class="mb-0 fw-semibold f-s-14" style="color: #ef4444;">Sign Out</p>
                                <p class="mb-0 f-s-11 text-muted">End your current session</p>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>

        <!-- Page Content -->
        <main>
          <div class="container-fluid">
            <slot></slot>
          </div>
        </main>
      </div>

      <!-- Footer -->
      <footer>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-9 col-12">
              <ul class="footer-text">
                <li>
                  <p class="mb-0">&copy; {{ new Date().getFullYear() }} Sheria Housing Co-operative Society. All rights reserved.</p>
                </li>
              </ul>
            </div>
            <div class="col-md-3">
              <ul class="footer-text text-end">
                <li><router-link to="/self-sort">Need Help <i class="ti ti-help"></i></router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <div class="go-top">
      <span class="progress-value"><i class="ti ti-arrow-up"></i></span>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/store';

export default {
  name: 'AppLayout',
  props: {
    pageTitle: {
      type: String,
      default: 'Dashboard'
    }
  },
  data() {
    return {
      isNavbarOpen: false,
      isMobile: false,
      navItems: [
        { path: '/', label: 'Dashboard', icon: 'ph-duotone ph-squares-four' },
        { path: '/transactions', label: 'Transactions', icon: 'ph-duotone ph-money' },
        { path: '/projects', label: 'Projects', icon: 'ph-duotone ph-buildings' },
        { path: '/plots', label: 'Plots', icon: 'ph-duotone ph-map-pin-line' },
        { path: '/profile', label: 'My Profile', icon: 'ph-duotone ph-user-circle' },
        { path: '/self-sort', label: 'Self Service', icon: 'ph-duotone ph-clipboard-text' },
      ],
      quickActions: [
        { path: '/', label: 'Dashboard', icon: 'ph-duotone ph-squares-four', bg: '#ecfeff', iconBg: '#cffafe', iconColor: '#0891b2', textColor: '#0e7490' },
        { path: '/transactions', label: 'Transactions', icon: 'ph-duotone ph-money', bg: '#ecfdf5', iconBg: '#d1fae5', iconColor: '#10b981', textColor: '#059669' },
        { path: '/projects', label: 'Projects', icon: 'ph-duotone ph-buildings', bg: '#eff6ff', iconBg: '#dbeafe', iconColor: '#3b82f6', textColor: '#2563eb' },
        { path: '/plots', label: 'Plots', icon: 'ph-duotone ph-map-pin-line', bg: '#fffbeb', iconBg: '#fef3c7', iconColor: '#f59e0b', textColor: '#d97706' },
        { path: '/profile', label: 'My Profile', icon: 'ph-duotone ph-user-circle', bg: '#faf5ff', iconBg: '#ede9fe', iconColor: '#8b5cf6', textColor: '#7c3aed' },
        { path: '/self-sort', label: 'Self Service', icon: 'ph-duotone ph-clipboard-text', bg: '#fff1f2', iconBg: '#fce7f3', iconColor: '#ec4899', textColor: '#db2777' },
      ],
    };
  },
  computed: {
    store() {
      return useUserStore();
    },
    userInitials() {
      const name = this.store.userName;
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }
  },
  mounted() {
    if (!this.store.isAuthenticated) {
      this.$router.push('/user-login');
    }
  },
  methods: {
    navigateQuickAction(path) {
      // Close the offcanvas programmatically
      const offcanvasEl = document.getElementById('appscanvasRights');
      if (offcanvasEl && window.bootstrap) {
        const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (bsOffcanvas) bsOffcanvas.hide();
      }
      this.$router.push(path);
    },
    handleLogout() {
      this.store.logout();
      this.$router.push('/user-login');
    }
  }
};
</script>

<style scoped>
.app-nav {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.main-nav.flex-grow-1 {
  flex-grow: 1;
}
.nav-link-item.active {
  background: rgba(8, 145, 178, 0.1);
  color: #0891b2 !important;
  border-radius: 8px;
}
</style>
